package com.isaias.fyattravel.web.pages.explore

// Real FYAT Travel & Tour WhatsApp business number — same one already used
// across Hotel/Car/Contact/Footer components sitewide. One-line change spot.
const val WA_NUMBER = "256758250625"

/** Builds a wa.me deep link with a properly URL-encoded pre-filled message. */
fun waLink(message: String): String {
    val encoded = js("encodeURIComponent")(message) as String
    return "https://wa.me/$WA_NUMBER?text=$encoded"
}
